var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tab-nav',{attrs:{"tabs":_vm.tabs},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}}),_c('div',{staticClass:"content"},[_c(_vm.currentTab.component,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }